// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Criteria = t.struct({
    model: t.String,
    pin: t.String
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        model: '',
        pin: ''
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/state/criteria.js